import _ from "lodash";
import TextField from "material-ui/TextField";
import React, { Component } from "react";
import Loader from "react-loader-advanced";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/user";
import ActionButton from "../components/common/ActionButton";
import Subtitle from "../components/common/Subtitle";
import Title from "../components/common/Title";
import UserService from "../services/user";
import layout from "../styles/layout";
import AppFrame from "./Appframe/AppFrame";

const DesktopStyle = {
  page: layout.common.page,
  container: {
    marginLeft: "20%",
    marginRight: "20%",
    padding: 10,
  },
  row: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "space-between",
    marginTop: 10,
    marginBottom: 20,
  },
  inputField: {
    width: "100%",
  },
  errorText: {
    color: "red",
  },
  successText: {
    color: "green",
  },
  btnContainer: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "space-around",
    marginTop: 10,
  },
};

const MobileStyle = {
  page: layout.common.page,
  container: {
    padding: 10,
  },
  row: {
    textAlign: "left",
    marginTop: 10,
    marginBottom: 20,
  },
  inputField: {
    width: "100%",
  },
  errorText: {
    color: "red",
  },
  successText: {
    color: "green",
  },
  btnContainer: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "space-around",
    marginTop: 10,
  },
};

class MyProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
      userId: props.match.params.userId,
      userAuth0Id: "",
      userInfo: {},
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      passwordError: "",
      passwordUpdateMsg: "",
      profileError: "",
      profileUpdateMsg: "",
      isLoading: false,
    };
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    if (this.state.userId > 0) {
      this.setState({ isLoading: true });
      this.props.getUserInfo(this.state.userId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.userInfo && nextProps.user.profile) {
      this.setState({
        userInfo: nextProps.user.userInfo,
        email: nextProps.user.userInfo.email,
        firstName: nextProps.user.userInfo.firstName,
        lastName: nextProps.user.userInfo.lastName,
        userAuth0Id: nextProps.user.profile.sub,
        isLoading: false,
      });
    }
  }

  updateProfile() {
    const emailRegex = /^[a-zA-Z0-9\+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailRegex.test(this.state.email)) {
      this.setState({ isLoading: true });

      const userInfo = {
        ...this.state.userInfo,
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
      };

      UserService()
        .updateUserInfo(this.state.userId, this.state.userAuth0Id, userInfo)
        .then((resp) => {
          if (!resp.isUserInfoUpdate) {
            this.setState({
              profileError: resp.updateMessage,
              profileUpdateMsg: "",
              isLoading: false,
            });
          } else {
            this.setState({
              profileError: "",
              profileUpdateMsg: resp.updateMessage,
              isLoading: false,
            });
            this.props.getUserInfo(this.state.userId);
          }
        });
    } else {
      this.setState({
        profileError: "You must enter a valid email address",
        profileUpdateMsg: "",
        isLoading: false,
      });
    }
  }

  updatePassword() {
    if (this.checkPassword()) {
      this.setState({ isLoading: true });
      UserService()
        .updateUserPassword(this.state.userAuth0Id, this.state.password)
        .then((resp) => {
          if (!resp.isPasswordUpdated) {
            this.setState({
              passwordError: resp.updateMessage,
              passwordUpdateMsg: "",
              isLoading: false,
            });
          } else {
            this.setState({
              passwordError: "",
              passwordUpdateMsg: resp.updateMessage,
              password: "",
              confirmPassword: "",
              isLoading: false,
            });
          }
        });
    }
  }

  checkPassword() {
    if (this.state.password.length < 9) {
      this.setState({
        passwordError: "Your password must have at least 9 characters",
      });
      return false;
    }
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        passwordError: "Password and Confirm Password values must match",
      });
      return false;
    }
    if (!/[a-z]/.test(this.state.password)) {
      this.setState({
        passwordError: "Password must contain a lower case letter",
      });
      return false;
    }
    if (!/[a-z]/.test(this.state.password)) {
      this.setState({
        passwordError: "Password must contain a lower case letter",
      });
      return false;
    }
    if (!/[A-Z]/.test(this.state.password)) {
      this.setState({
        passwordError: "Password must contain an UPPER CASE letter",
      });
      return false;
    }
    if (!/[0-9]/.test(this.state.password)) {
      this.setState({
        passwordError: "Password must contain at least one number (0-9)",
      });
      return false;
    }

    if (!/[`!@#$%^&*()_\-+=\[\]{};':"\\|,.<>\/?~ ]/.test(this.state.password)) {
      this.setState({
        passwordError:
          "Password must contain at least one special character (!@#$%^&*()_-+=<>?)",
      });
      return false;
    }

    if (/(.)\1\1/.test(this.state.password)) {
      this.setState({
        passwordError:
          "Password may not contain three repeating letters or numbers",
      });
      return false;
    }

    return true;
  }

  render() {
    let targetDevice = "desktop";
    let style = DesktopStyle;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
      style = MobileStyle;
    }
    return (
      <AppFrame
        auth={this.props.auth}
        header="My Profile"
        optionsType="profile"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={style.page}>
          <Loader show={this.state.isLoading} message={"Loading..."}>
            <div style={style.container}>
              <br />
              <Subtitle text="User Info" />
              <div state={style.row}>
                <TextField
                  type="email"
                  style={style.inputField}
                  hintText="Enter your Email"
                  floatingLabelText="Email"
                  value={this.state.email}
                  onChange={(event) =>
                    this.setState({
                      email: event.target.value,
                    })
                  }
                />
              </div>
              <div state={style.row}>
                <TextField
                  style={style.inputField}
                  hintText="Enter your first name"
                  floatingLabelText="First Name"
                  value={this.state.firstName}
                  onChange={(event) =>
                    this.setState({
                      firstName: event.target.value,
                    })
                  }
                />
              </div>
              <div state={style.row}>
                <TextField
                  style={style.inputField}
                  hintText="Enter your last name"
                  floatingLabelText="Last Name"
                  value={this.state.lastName}
                  onChange={(event) =>
                    this.setState({
                      lastName: event.target.value,
                    })
                  }
                />
              </div>

              {!_.isEmpty(this.state.profileError) && (
                <p style={style.errorText}>{this.state.profileError}</p>
              )}
              {!_.isEmpty(this.state.profileUpdateMsg) && (
                <p style={style.successText}>{this.state.profileUpdateMsg}</p>
              )}

              <div style={style.btnContainer}>
                <ActionButton
                  label="Update User Info"
                  onClick={() => this.updateProfile()}
                  disabled={
                    this.state.email === "" ||
                    this.state.firstName === "" ||
                    this.state.lastName === ""
                  }
                  whiteLabelSettings={this.props.whiteLabelSettings}
                />
              </div>

              <br />
              <Subtitle text="Password" />

              <div state={style.row}>
                <TextField
                  type="password"
                  style={style.inputField}
                  hintText="Enter your Password"
                  floatingLabelText="Password"
                  value={this.state.password}
                  onChange={(event) =>
                    this.setState({
                      password: event.target.value,
                      passwordError: "",
                      passwordUpdateMsg: "",
                    })
                  }
                />
              </div>

              <div state={style.row}>
                <TextField
                  type="password"
                  style={style.inputField}
                  hintText="Enter confirm Password"
                  floatingLabelText="Confirm Password"
                  value={this.state.confirmPassword}
                  onChange={(event) =>
                    this.setState({
                      confirmPassword: event.target.value,
                      passwordError: "",
                      passwordUpdateMsg: "",
                    })
                  }
                />
              </div>

              <div state={style.row}>
                {!_.isEmpty(this.state.passwordError) && (
                  <p style={style.errorText}>{this.state.passwordError}</p>
                )}
                {!_.isEmpty(this.state.passwordUpdateMsg) && (
                  <p style={style.successText}>
                    {this.state.passwordUpdateMsg}
                  </p>
                )}
              </div>

              <div style={style.btnContainer}>
                <ActionButton
                  label="Update Password"
                  onClick={() => this.updatePassword()}
                  disabled={
                    this.state.password === "" ||
                    this.state.confirmPassword === ""
                  }
                  whiteLabelSettings={this.props.whiteLabelSettings}
                />
              </div>
            </div>
          </Loader>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, whiteLabelSettings }) {
  return {
    userId: user.userId,
    user,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);



// WEBPACK FOOTER //
// ./src/layout/MyProfile.js